import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { AppBaseDropdown } from '@pro-sto/ui';
import { UserIcon, LogoutIcon } from '@pro-sto/ui';
import { useStores } from '@/hooks';
import ConfirmLogoutModal from './ConfirmLogoutModal';
import './AppHeaderMenu.css';

const AppHeaderMenu: React.FC = observer(() => {
  const { authStore } = useStores();
  const [isOpen, setIsOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
    setIsOpen(false);
  };

  const handleLogoutConfirm = () => {
    setShowLogoutConfirm(false);
    authStore.logout();
  };

  const handleLogoutCancel = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      <AppBaseDropdown
        opened={isOpen}
        onClose={() => setIsOpen(false)}
        dropdownWidth="197px"
        xDirection="left"
        yDirection="bottom"
        toggle={
          <button 
            className="app-header-menu__profile-button" 
            onClick={() => setIsOpen(!isOpen)} 
            aria-label="Открыть меню профиля" 
            data-testid="user-menu-button"
          >
            <UserIcon />
          </button>
        }
        dropdown={
          <div className="app-header-menu-dropdown">
            <button 
              className="app-header-menu__item" 
              onClick={handleLogoutClick} 
              data-testid="menu-logout"
            >
              <div className="app-header-menu__icon"><LogoutIcon /></div>
              <span className="app-header-menu__label">Выход</span>
            </button>
          </div>
        }
      />

      <ConfirmLogoutModal
        isOpen={showLogoutConfirm}
        onConfirm={handleLogoutConfirm}
        onCancel={handleLogoutCancel}
      />
    </>
  );
});

AppHeaderMenu.displayName = 'AppHeaderMenu';

export default AppHeaderMenu;
